"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.fetchDiaryStats = exports.createStatsResponse = void 0;
const t = require("io-ts");
const rxjs_1 = require("rxjs");
const operators_1 = require("rxjs/operators");
const ActionTypes = require("../../actionTypes/diaryentries/stats");
const Actions = require("../../actions/diaryentries/stats");
const sok_types_1 = require("@caddigital/sok-types");
const errorHandling_1 = require("../../utils/errorHandling");
exports.createStatsResponse = t.array(sok_types_1.WorksiteDiaryStats.iWorksiteDiaryStats);
function fetchDiaryStats(action$, store, { ajax, getToken, baseUrl }) {
    return action$.pipe((0, operators_1.filter)((action) => action.type === ActionTypes.FETCH_REQUEST), (0, operators_1.mergeMap)((action) => ajax({
        headers: {
            'Content-Type': 'application/json',
            Authorization: getToken()
        },
        method: 'GET',
        url: `${baseUrl}api/worksitediary/${action.diaryUuid}/stats`
    }).pipe((0, operators_1.mergeMap)((xhr) => {
        return sok_types_1.WorksiteDiaryStats.iWorksiteDiaryStats
            .decode(xhr.response)
            .fold((error) => (0, rxjs_1.of)(Actions.fetchFailed((0, errorHandling_1.parseValidationError)(error))), (cases) => (0, rxjs_1.of)(Actions.fetchSuccess(cases)));
    }), (0, operators_1.catchError)((error) => (0, rxjs_1.of)(Actions.fetchFailed((0, errorHandling_1.parseAjaxErrorResponse)(error)))))));
}
exports.fetchDiaryStats = fetchDiaryStats;
//# sourceMappingURL=stats.js.map